









import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {

  },
})
export default class ExerciseItem extends Vue {
  private clicks: number = 0;
  private timer: any = null;

  @Prop()
  private id!: string;

  @Prop({default: ''})
  private img?: string;

  @Prop({default: ''})
  private title!: string;

  private handleClick() {
    this.clicks++
    if(this.clicks === 1) {
      var self = this
      this.timer = setTimeout(function() {
        console.log('click');
        self.clicks = 0
      }, 700);
    } else{
      clearTimeout(this.timer);

      console.log('dblclick');
      this.clicks = 0;
    }
  }

}
